import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocale'
})
export class UtcToLocalePipe implements PipeTransform {

  transform(utcDate: string): string {

    let indexOfDate = utcDate.indexOf('+');

    if (isNaN(indexOfDate)) {
      indexOfDate = utcDate.indexOf('-');
    }

    const newDateParsedToNumber = Date.parse(utcDate.substr(0, indexOfDate - 1));

    const newDate = new Date(newDateParsedToNumber);

    const offset = newDate.getTimezoneOffset() / 60;

    const sign = newDate.toString().substr(newDate.toString().indexOf('GMT') + 3, 1);

    if (sign === '+') {
      newDate.setHours( newDate.getHours() + offset );
    } else {
      newDate.setHours( newDate.getHours() - offset );
    }

    return newDate.toLocaleString();
  }

}
